/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseListVehicleSettingResponse } from '../models/ApiResponseListVehicleSettingResponse';
import type { ApiResponseVehicleSettingResponse } from '../models/ApiResponseVehicleSettingResponse';
import type { ApiResponseVoid } from '../models/ApiResponseVoid';
import type { UpdateVehicleSettingCommand } from '../models/UpdateVehicleSettingCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class VehicleSettingControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 차량 특정 설정정보 조회
   * 차량의 특정 설정정보를 조회합니다.
   * @returns ApiResponseVehicleSettingResponse OK
   * @throws ApiError
   */
  public getVehicleSetting({
    vin,
    settingType,
    authorization,
  }: {
    vin: string,
    settingType: 'LOCK_DRIVE_RECORD' | 'DISPLAY_FUEL_EFFICIENCY',
    authorization?: string,
  }): CancelablePromise<ApiResponseVehicleSettingResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/vehicles/{vin}/settings/{settingType}/',
      path: {
        'vin': vin,
        'settingType': settingType,
      },
      headers: {
        'Authorization': authorization,
      },
    });
  }
  /**
   * 차량 특정 설정정보 업데이트
   * 차량의 특정 설정정보를 업데이트합니다.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public updateVehicleSetting({
    vin,
    settingType,
    authorization,
    requestBody,
  }: {
    vin: string,
    settingType: 'LOCK_DRIVE_RECORD' | 'DISPLAY_FUEL_EFFICIENCY',
    authorization?: string,
    requestBody: UpdateVehicleSettingCommand,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/vehicles/{vin}/settings/{settingType}/',
      path: {
        'vin': vin,
        'settingType': settingType,
      },
      headers: {
        'Authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 차량 특정 설정정보 조회
   * 차량의 특정 설정정보를 조회합니다.
   * @returns ApiResponseVehicleSettingResponse OK
   * @throws ApiError
   */
  public getVehicleSetting1({
    vin,
    settingType,
    authorization,
  }: {
    vin: string,
    settingType: 'LOCK_DRIVE_RECORD' | 'DISPLAY_FUEL_EFFICIENCY',
    authorization?: string,
  }): CancelablePromise<ApiResponseVehicleSettingResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/vehicles/{vin}/settings/{settingType}',
      path: {
        'vin': vin,
        'settingType': settingType,
      },
      headers: {
        'Authorization': authorization,
      },
    });
  }
  /**
   * 차량 특정 설정정보 업데이트
   * 차량의 특정 설정정보를 업데이트합니다.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public updateVehicleSetting1({
    vin,
    settingType,
    authorization,
    requestBody,
  }: {
    vin: string,
    settingType: 'LOCK_DRIVE_RECORD' | 'DISPLAY_FUEL_EFFICIENCY',
    authorization?: string,
    requestBody: UpdateVehicleSettingCommand,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/vehicles/{vin}/settings/{settingType}',
      path: {
        'vin': vin,
        'settingType': settingType,
      },
      headers: {
        'Authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 차량 설정정보 조회
   * 차량의 설정정보를 조회합니다.
   * @returns ApiResponseListVehicleSettingResponse OK
   * @throws ApiError
   */
  public getVehicleSettings({
    vin,
    authorization,
  }: {
    vin: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseListVehicleSettingResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/vehicles/{vin}/settings/',
      path: {
        'vin': vin,
      },
      headers: {
        'Authorization': authorization,
      },
    });
  }
  /**
   * 차량 설정정보 조회
   * 차량의 설정정보를 조회합니다.
   * @returns ApiResponseListVehicleSettingResponse OK
   * @throws ApiError
   */
  public getVehicleSettings1({
    vin,
    authorization,
  }: {
    vin: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseListVehicleSettingResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/vehicles/{vin}/settings',
      path: {
        'vin': vin,
      },
      headers: {
        'Authorization': authorization,
      },
    });
  }
}
